import { render } from "./v-form.vue?vue&type=template&id=f5592e1c"
import script from "./v-form.vue?vue&type=script&lang=js"
export * from "./v-form.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/v-form.vue'],['render',render],['__file',"v-form.vue"]])

export default __exports__